import React from 'react';
import { REPORTS_NAV } from '../../reports/config';
import type { ReportsPageId } from '../../reports/types';

export interface ReportsSubNavProps {
  active: ReportsPageId;
  onChange: (id: ReportsPageId) => void;
}

export function ReportsSubNav({ active, onChange }: ReportsSubNavProps) {
  return (
    <nav className="rpt-root sticky top-0 flex w-[244px] flex-none flex-col gap-3.5 overflow-auto border-r border-[var(--cream-2)] bg-[var(--cream-0)] py-[26px] pb-5">
      <div className="px-5">
        <div className="rpt-eyebrow mb-1">Reports</div>
        <h2 className="m-0 text-[22px] font-medium leading-[1.05] tracking-[-0.025em] text-[var(--ink-0)]">
          What Elva <span className="rpt-count-gradient">learned</span>
        </h2>
      </div>

      <div className="flex flex-col">
        {REPORTS_NAV.map((item) => {
          const isActive = active === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onChange(item.id)}
              className={[
                'rpt-subnav-btn flex w-full cursor-pointer items-center justify-between border-0 py-2.5 text-left text-[13px] tracking-[-0.005em] transition-[background,color] duration-[140ms]',
                isActive ? 'rpt-subnav-btn-active font-semibold text-[var(--ink-0)]' : 'bg-transparent font-medium text-[var(--ink-1)]',
              ].join(' ')}
              style={{
                paddingLeft: isActive ? 17 : 20,
                paddingRight: 14,
                background: isActive ? 'rgba(15, 92, 69, 0.05)' : 'transparent',
                borderLeft: `3px solid ${isActive ? '#0F5C45' : 'transparent'}`,
              }}
            >
              <span>{item.label}</span>
              {isActive && <span className="h-[5px] w-[5px] rounded-full" style={{ background: '#0F5C45' }} />}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
